module.exports = __webpack_public_path__ + "img/cooperative0_logo33.e6336d69.jpg";